
import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatBottomSheet, MatDialog } from '@angular/material';
import { Paytype } from '../../../models/paytype.model';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { Member } from '../../../models/member.model';
import { AccountService } from '../../../services/account.service';
import { Permission } from '../../../models/permission.model';
import { AuthService } from '../../../services/auth.service';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { BookmarkTemplateService } from '../../../services/bookmark-template.service';
import { TemplateFormComponent } from '../template-form/template-form.component';
import { DocumentTemplate } from '../../../models/document-template.model';
import { DocumentTemplateFormValueService } from '../../../services/document-template-form-value.service';
import { User } from '../../../models/user.model';
import { SnotifyService } from 'ng-snotify';


@Component({
    selector: 'case-detail',
    template: require('./case-detail.component.html'),
    styles: [require('./case-detail.component.css')]
})
export class CaseDetailComponent implements OnInit {

    isLoading = true;
    currentUser: User
    currentMember: Member;
    currentCase: any = {};
    cmNotes = [];
    caseType = "Pre-authorization";
    eventLogs: Array<any> = [];
    vendorProductId: number;
    writeMembersPermission = Permission.writeMembersPermission;
    manageefulfillmentPermission = Permission.manageefulfillmentPermission;
    ffs = [];
    newFile: any;
    generatingMemberCard: boolean = false;
    sending1stEmail: boolean = false;

    files: any = [];

    policyNumber_eFulfillment = {};
    documentTemplates = [];
    providers = [];

    sendFileVM = {
        faxNumber: '19727674531', rawStringsForm: [], cMPatient: {}, caseNum: '', documentTemplateId: '', cMProvider: {}, generateFileOnly: false, contactType: 0
    };

    caseNum: string = "";
    needForm: boolean = false;
    isUpdateTemplate: boolean = false;
    templateFormValue: DocumentTemplate;
    selectedPatient: any = {}
    selectedProvider: any = {}

    sendingFile = false;
    isSaveFileOnly: boolean = false;
    memberProviderList = [];
    isSendProviderEmail: boolean = false;

    constructor(private bottomSheet: MatBottomSheet, private snotifyService: SnotifyService, private apiService: ApiService, public accountService: AccountService,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private bookmarkTemplateService: BookmarkTemplateService,
        public dialog: MatDialog,
        private dtFormValueService: DocumentTemplateFormValueService,
        private spinner: NgxSpinnerService) {

  
        // var memberId = this.activatedRoute.snapshot.params["memberId"];
        this.caseNum = this.activatedRoute.snapshot.params["caseNum"];
        this.sendFileVM.caseNum = this.caseNum;
        this.getCaseDetail(this.caseNum);
        this.getDocTemplates();
        this.searchProviders();
        this.currentUser = accountService.currentUser;
        //console.log(this.currentUser)
    /*this.currentCase.CMPatients;*/
        //console.log(this.currentCase)
    }
    ngOnInit(): void {

    }

    selectMemberProvider(e) {
        //console.log(e)
        if (e instanceof Object) {// check provider

            this.isSendProviderEmail = _.isEmpty(e.email);
            //send fax
            this.sendFileVM.faxNumber = e.fax;
            this.selectedProvider = e;
            //console.log(this.sendFileVM)
        } else {
            this.isSendProviderEmail = false;
            this.selectedProvider = {} as any;

        }
        this.sendFileVM.cMProvider = this.selectedProvider;
        //console.log(this.isSendProviderEmail)
    }

    getMemberProviderList() {
        console.log(this.currentCase)
        this.currentCase.cmMember.displayName = this.currentCase.cmMember.firstName + ' ' + this.currentCase.cmMember.lastName + '(member)';
        this.memberProviderList.push(this.currentCase.cmMember)
        this.currentCase.cmProviders.forEach(i => {
            i.displayName = `${i.name + i.pid} (provider)`;
            this.memberProviderList.push(i);
        })

        //console.log(this.memberProviderList);
    }

    

    saveFileOnly() {
        this.sendFileVM.generateFileOnly = true;
        this.sendDoc();
    }

    updateNoteFormValue(n) {
        this.dtFormValueService.getDocumentTemplateFormData(n.relatedFileID).subscribe(r => {
            if (r && r.length > 0) {
               // console.log(r)
                this.bookmarkTemplateService.getTemplateById(r[0].documentTemplateBookmark.documentTemplateId).subscribe(template => {
                    var tempDocumentTemplate = template;
                  //  console.log(tempDocumentTemplate.documentTemplateBookmarks)
                    tempDocumentTemplate.documentTemplateBookmarks.forEach(b => {
                        b.bookmarkPathValueNew = r.find(i => i.documentTemplateBookmark.id == b.id) ? r.find(i => i.documentTemplateBookmark.id == b.id).fieldValue : ''
                    })
                    tempDocumentTemplate.needForm = _.some(tempDocumentTemplate.documentTemplateBookmarks, { bookmarkPathValue: 'needForm' })
                  
                    this.updateFormValue(tempDocumentTemplate, "",true);
                })
            } else{
                this.updateFormValue({ documentTemplateBookmarks: [], documentTemplateId: n.documentTemplateId } as any, null, true);
            }
        })
    }

    editTemplateForm() {
       // console.log(this.templateFormValue)
        this.updateFormValue(this.templateFormValue);
    }

    updateFormValue(template: DocumentTemplate, patientId?: string, resend = false) {
        let dialogRef = null;

        dialogRef = this.dialog.open(TemplateFormComponent, {
            data: {
                template: template,
                patients: this.currentCase.cmPatients,
                selectedPatient: this.selectedPatient,
                patientId: patientId,
                providers: this.currentCase.cmProviders,
                selectedProvider: this.selectedProvider,
                isSendProviderEmail: this.isSendProviderEmail,
            },
            panelClass: 'col-sm-10',
            disableClose: true,
            height: 'auto'
        })

        dialogRef.afterClosed().subscribe(r => {
            if (r) {
                console.log(r)
                this.templateFormValue = r.template;
                this.selectedPatient = r.selectedPatient,
                    this.selectedProvider = r.selectedProvider,
                    this.sendFileVM.cMPatient = this.selectedPatient;
                this.sendFileVM.cMProvider = this.selectedProvider;
                this.sendFileVM.rawStringsForm = _.map(template.documentTemplateBookmarks, (i: any) => {
                    return {
                        key: i.bookmark,
                        value: i.bookmarkPathValueNew
                    }
                });
                if (resend) {
                    this.sendFileVM.documentTemplateId = r.template.documentTemplateId
                    //this.sendDoc();
                    this.needForm = true;
                    this.isUpdateTemplate = true;
                    this.isSaveFileOnly = true;
                }
                this.isUpdateTemplate = true;
            } else {
                //console.log('close')
                this.sendFileVM.documentTemplateId = "";
                this.isSaveFileOnly = false;
                this.isUpdateTemplate = false;
            }
        })
    }

    selectTemplate(templateId) {
        this.bookmarkTemplateService.getTemplateById(templateId).subscribe(r => {
            if (this.currentUser.roles.some(i => i === 'Full')) {
                this.isSaveFileOnly = true;
            }
            r.needForm = _.some(r.documentTemplateBookmarks, {bookmarkPathValue: 'needForm'})
            r.havePatient = _.some(r.documentTemplateBookmarks, { bookmarkPathValue: 'needPatientDropDown' })
            r.haveProvider = _.some(r.documentTemplateBookmarks, { bookmarkPathValue: 'needProviderDropDown' })

            if (r.needForm || r.havePatient || r.haveProvider) {
                this.templateFormValue = r
                this.updateFormValue(this.templateFormValue)
                this.needForm = true;
                return
            }
        })

    }

    getDocTemplates() {
        this.apiService.umapGetDocumentTemplates().subscribe(r => {
            this.documentTemplates = r.sort((a, b) => a.orderIndex - b.orderIndex);
        })
    }

    searchProviders() {
        this.apiService.umapSearchProviders().subscribe(r => {
            this.providers = r;
        })
    }

    sendDoc() {
        this.sendingFile = true;
        this.snotifyService.info("Sending Doc");
        this.apiService.umapSendFile(this.currentMember.memberId, this.sendFileVM).subscribe(r => {
            this.snotifyService.success("Send Doc successfully!");

            var templateData = [];
            if (this.templateFormValue) {
                var templateData = _.map(this.templateFormValue.documentTemplateBookmarks, (i: any) => {
                    if (i.bookmarkPathValue == 'needPatientDropDown') {
                        return {
                            key: i.id,
                            value: this.selectedPatient.id
                        }
                    } else {
                        return {
                            key: i.id,
                            value: i.bookmarkPathValueNew
                        }
                    }
                });
            }

            this.dtFormValueService.saveFormData(r, templateData).subscribe(r => {
                //console.log(111111)
            })

            this.fetchFiles();
            this.sendingFile = false;
        }, err => {
                this.sendingFile = false;
                this.snotifyService.error( err.error)
        })
    }

    ok() {
        
    }

    getCaseDetail(caseNum) {
        this.isLoading = true;
        this.apiService.umapGetCaseDetail(this.caseNum).subscribe(r => {
            this.isLoading = false;
            this.currentCase = r || {};
            this.currentMember = r.cmMember;
  
            this.fetchFiles();
            this.getMemberProviderList()
            
        });
    }

    private fetchFiles() {
        //this.apiService.getFoldersAndFiles(this.currentSmartVaultClient.id).subscribe(ffsres => {
        //    this.ffs = ffsres;
        //});
        this.apiService.umapGetCMNotes(this.currentCase.caseNum).subscribe(rCMNotes => {
            this.cmNotes = rCMNotes;

            var ids = _.map(this.cmNotes, n => {
                return n.relatedFileID;
            });

            this.apiService.umapGetDocuments(ids).subscribe(docs => {
                _.each(this.cmNotes, cmNote => {
                    cmNote.documentMaster = _.find(docs, {documentId: cmNote.relatedFileID})
                })
            })

        });
    }


    createSmartVaultClient() {
        //this.isLoading = true;
        //this.apiService.createCaseManagement(this.caseType, this.currentMember).subscribe(r => {
            
        //    this.currentCase = r;
        //    if (this.currentCase.id) {
        //        this.fetchFiles();
        //    }

        //    //send email
        //    this.apiService.umapSendFile(this.currentMember.memberId, {
        //        documentTemplateId: 1
        //    }).subscribe(res => {
        //        this.isLoading = false;

        //        this.apiService.umapGetCMNotes(this.currentCase.caseNum).subscribe(rCMNotes => {
        //            this.cmNotes = rCMNotes;
        //        });
        //    })

        //});
    }

    getFiles(event) {
        this.newFile = event.target.files[0];

    } 

    uploadFile(event) {
        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            this.files.push(element)
        }
    }

    upload() {
        this.spinner.show();
        _.each(this.files, f => {

            this.apiService.uploadFilesSmartVault(this.currentCase.id, f).subscribe(r =>
            {
             
                if (this.files.length == 0) {
                    this.spinner.hide();
                    this.fetchFiles();
                }
            });

        });
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cases-management/case-detail/case-detail.component.ts